<template>
  <div class="flex float-left vertical-center">
    <vs-button
      v-bind:id="'btn-row-unpair-'+rowNumber"
      v-if="isProvisioned =='provisioned' && status === 'active' "
      size="small"
      icon-pack="feather"
      icon="icon-toggle-left"
      @click="unpairRecord"
      color="warning"
      class="mr-2"
    ></vs-button>
    <vs-button
      v-bind:id="'btn-row-unpair-disable-'+rowNumber"
      v-else
      size="small"
      icon-pack="feather"
      icon="icon-toggle-left"
      disabled="true"
      color="warning"
      class="mr-2"
    ></vs-button>
    <vs-button
      v-if="status!=='' && isConfigure"
      v-bind:id="'btn-row-config-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-settings"
      color="dark"
      class="mr-2"
      @click="configRecord"
    ></vs-button>
    <vs-button
      v-bind:id="'btn-detail-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-list"
      @click="detailRecord"
      color="primary"
      v-if="isDetail"
      class="mr-2"
    ></vs-button>
    <vs-button
      v-bind:id="'btn-delete-device-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-trash"
      @click="deleteRecord"
      color="danger"
      class="mr-2"
    ></vs-button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ActionTableAgGridComponent",
  data() {
    return {
      isConfigure: false,
      isDetail: false,
      isProvisioned: "",
      status:"",
      rowNumber: 0,
    };
  },
  methods: {
    unpairRecord() {
      this.$root.$emit(
        "unpair-from-ActionTableAgGridComponent",
        this.params.value
      );
    },
    configRecord(){
      this.$root.$emit(
              "config-from-ActionTableAgGridComponent",
              this.params.value
      )
    },
    detailRecord() {
      this.$root.$emit(
        "detail-from-ActionTableAgGridComponent",
        this.params.value
      );
    },
    deleteRecord() {
      let payload = {
        id : this.params.value,
        status : this.params.data.status_device,
        isProvisioned : this.params.data.status_provision,
        deviceCode : this.params.data.device_code
      }
      this.$root.$emit(
        "delete-device-from-ActionTableAgGridComponent",
        payload
      );
    }
  },
  created() {
    this.isProvisioned=this.params.data.status_provision
    this.status = this.params.data.status_device
    this.isConfigure = false;
    this.isDetail = true;
    this.rowNumber = this.params.data.no
  },
});
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>